import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import './Projects.scss';

const ProjectShape = {
  id: PropTypes.number.isRequired,
  hackathon: PropTypes.string.isRequired,
  idea_descr: PropTypes.string.isRequired,
  images: PropTypes.array.isRequired, // No ideas of the array type
  links: PropTypes.array.isRequired, // No ideas of the array type
  name: PropTypes.string.isRequired,
  project_descr: PropTypes.string.isRequired,
  status: PropTypes.number.isRequired,
  table: PropTypes.string.isRequired,
  team: PropTypes.arrayOf(
    PropTypes.shape({
      username: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
    })
  ).isRequired,
  technologies: PropTypes.array.isRequired, // No ideas of the array type
};

const Project = (props) => {
  const { project } = props;
  return (
    <div className='cabinet_project'>
      <div className='cabinet_project-date'>ИЮНЬ 2018</div>
      <h1 className='cabinet_project-title'>{project.name}</h1>
      <p className='cabinet_project-description'>{project.project_descr}
    </p>
      <div className="projects-tags">
        <div className="projects-tag">Hackerman_1</div>
        <div className="projects-tag">Hackerman_2</div>
        <div className="projects-tag">Hacker_3</div>
      </div>
      <div className='to-project-btn'>
        <Link to={`/edit_project/${project.id}`}>
          <span className="right"></span>
        </Link>
      </div>
    </div>
  )
}
Project.propTypes = {
  project: PropTypes.shape(ProjectShape),
};


class Projects extends Component {
  render() {
    const { history } = this.props;
    return (
      <div className='cabinet_projects'>
        <div className="projects_add-btn-wrapper">
          <button className='projects_add-btn' onClick={() => history.push('/add_project')}>+ Добавить проект</button>
        </div>
        <div className='separate-line' />
        <div className="projects-wrapper">
          {
            this.props.projects.map((project) => <Project key={project.id} project={project} />)
          }
        </div>
      </div>
    );
  }
}


Projects.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  projects: PropTypes.arrayOf(
    PropTypes.shape(ProjectShape),
  ),
}

export default withRouter(Projects);




// WEBPACK FOOTER //
// ./src/components/Account/Projects/index.js